import React from "react";

import WarningIcon from "images/warning-icon.png";
import CheckIcon from "images/check-circle-green.png";
import CloseIcon from "images/close-black.png";

const Alert = ({ success, message, onClose }) => {
  return (
    <div className="w-full flex justify-between items-center bg-white py-4 px-5 rounded mt-6">
      <div className="flex items-center justify-start">
        <img
          src={success ? CheckIcon : WarningIcon}
          alt="alert image"
          className="w-6 h-6 mr-2"
        />

        <p
          className={`font-sans text-sm font-semibold ${
            success ? "text-green-700" : "text-yellow-400"
          }`}
        >
          {message}
        </p>
      </div>
      <button onClick={onClose}>
        <img src={CloseIcon} alt="close icon" className="w-6 h-6" />
      </button>
    </div>
  );
};

export default Alert;
